import * as React from "react";
import { AppLayout, ILeadAction, Lead, useLead360 } from "../../core";
import "../../styles/full-view-popup.scss";
import "../../styles/sales-person.scss";
import "../../styles/tags.scss";
import "../../styles/requirement.scss";

import { PropertyDetailTabNames } from "./props";
import PropertyDetailTabs from "./PropertyDetailTabs";
import PropertyOverview from "./propertyOverview";
import api from "../../api";
import { useDataLoader } from "react-remote-data-hooks";
import { ContainerLoader } from "../../components/loader";
import { Property } from "../../core/api/models/property";
import Lead360Activities from "../global-search/components/Lead360Activities";
import ActionModal from "../lead-360-view/components/lead-details/actions/ActionModal";
import { ActivityCategory } from "../requirement/components/props";

interface IPropertyDetailsPageProps {
  onClose: () => void;
  projectId?: string;
  type?: string;
}

const PropertyDetailPage: React.FunctionComponent<IPropertyDetailsPageProps> = (
  props
) => {
  const [
    propertyDetailTabName,
    setPropertyDetailTabName,
  ] = React.useState<PropertyDetailTabNames>(PropertyDetailTabNames.Overview);
  const handlePropertyDetailTabChange = (
    tabNameValue: PropertyDetailTabNames
  ) => {
    setPropertyDetailTabName(tabNameValue);
  };


  const { data: project, loaded } = useDataLoader<Property>(() =>
    api.property.getPropertyDetails(props.projectId!)
  );

  const [reloadActivity, setReloadActivity] = React.useState(false)
  const [actionDetailsData, setActionDetailsData] = React.useState<{
    isModalOpen?: boolean;
    action?: ILeadAction;
    leads?: Lead[];
  }>({});
  const { allLeads, company, reload } = useLead360(api.lead);

  const [detailsLoaded, setISLoaded] = React.useState(false);

  React.useEffect(() => {
    if (loaded) {
      const timer = setTimeout(() => {
        setISLoaded(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [loaded]);



  const renderHeader = () => {
    return (
      <div className="container-fluid bg-gray-100 border-bottom py-4 position-sticky top-0 zIndex-9">
        <div className="row align-items-center">
          <div
            className="col-auto font-md font-weight-semibold text-gray-500 d-flex align-items-center cursor-pointer"
            onClick={props.onClose}
          >
            <i className="icon-chevron-left text-gray-500 font-base cursor-pointer mr-2"></i>
            Back
          </div>

        </div>
      </div>
    );
  };

  const otherAction: ILeadAction = {
    name: "Create Activity",
    code: "call",
    _id: "call",
  };

  const addActivity = () => {
    setActionDetailsData({
      isModalOpen: true,
      action: otherAction,
      leads: allLeads,
    });
  }

  return (
    <AppLayout>
      <div className=""  style={{ zIndex: 9999}}>
        <>
          <div className="detail-poupup position-fixed top-0 w-100 h-100 overflow-auto in">
            {renderHeader()}
            <div className="container-fluid px-4 bg-white min-vh-100 pt-3 pb-5">
              {detailsLoaded ? (
                <>
                  <div className="">
                    <PropertyDetailTabs
                      tabName={propertyDetailTabName}
                      tabChangeHandler={handlePropertyDetailTabChange}
                    />
                  </div>
                  {PropertyDetailTabNames.Overview ===
                    propertyDetailTabName && (
                      <PropertyOverview
                        onClose={props.onClose}
                        project={project}
                      />
                    )}

                  {PropertyDetailTabNames.Activities ===
                    propertyDetailTabName && (
                      <>
                        <Lead360Activities
                          cssClass="addactivity-wrap"
                          leads={[]}
                          activityCategory={ActivityCategory.Property}
                          activityCategoryId={props.projectId}
                          addActivity={() => { addActivity(); setReloadActivity(false) }}
                          reloadActivity={reloadActivity} />
                      </>
                    )}

                  {PropertyDetailTabNames.LocationMap ===
                    propertyDetailTabName && (
                      <div className="pt-3">
                        <div className="col-12 px-0">
                          <h2 className="mb-4">Location Map</h2>
                        </div>
                        <div
                          className="col px-0 mb-3"
                          style={{ maxWidth: "626px" }}
                        >
                          <iframe
                            src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyDswP272vF5WZVy9n8lBai1df9bbuvzblI&q=${project?.propertyAddress1}`}
                            width="626"
                            height="315"
                            loading="lazy"
                            className="border-0"
                          ></iframe>
                        </div>
                        <div className="col-12 px-0 font-sm">
                          <div className="mb-1">{project?.city?.cityName}</div>
                          <div>
                            <i className="icon-location-filled mr-2 text-gray-500"></i>
                            {project?.propertyAddress1}
                          </div>
                        </div>
                      </div>
                    )}
                </>
              ) : (
                <>
                  <ContainerLoader></ContainerLoader>
                </>
              )}
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      </div>
      {/* available unit  */}
      {actionDetailsData.isModalOpen && (
        <ActionModal
          onClose={() => setActionDetailsData({})}
          action={actionDetailsData.action!}
          reload={() => setReloadActivity(true)}
          activityCategory={ActivityCategory.Property}
          activityCategoryId={props.projectId}
        ></ActionModal>
      )}
    </AppLayout>
  );
};

export default PropertyDetailPage;
